import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withFeatureFlags } from '@atlassian/mpac-ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../constants/proptypes/AddonDiscoveryPropTypes";
import { resolveDiscoverHeadingText } from "../utils/headings";
import TextSearchWrapper from "./common/TextSearch/TextSearchWrapper";

var HeroWrapper = /*#__PURE__*/function (_Component) {
  _inherits(HeroWrapper, _Component);

  var _super = _createSuper(HeroWrapper);

  function HeroWrapper() {
    _classCallCheck(this, HeroWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(HeroWrapper, [{
    key: "render",
    value: function render() {
      var _this$props;

      var Hero = this.props.heroComponent;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextSearchWrapper, {
        filters: this.props.filters,
        searchComponent: Hero,
        extraProps: {
          discoverHeading: resolveDiscoverHeadingText({
            filters: this.props.filters,
            featureFlags: {
              enableJsdToJsm: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.enableJsdToJsm
            }
          }),
          filters: this.props.filters
        },
        perspective: this.props.perspective,
        stateChangeRequested: this.props.stateChangeRequested
      }));
    }
  }]);

  return HeroWrapper;
}(Component);

_defineProperty(HeroWrapper, "propTypes", {
  heroComponent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  enableJsdToJsm: PropTypes.bool
});

export default withFeatureFlags(HeroWrapper);